import Vue from 'vue'
import App from './app.vue'
import Global from '../../../components/jiri/Global'
import browers from '../../../../plugins/browser.js'

var VueTouch = require('vue-touch')
Vue.use(VueTouch, { name: 'v-touch' })
import AwesomePicker from 'vue-awesome-picker'
Vue.use(AwesomePicker)

// 计算自适应手机屏幕宽
var remSize = Global.setPhoneRem()
document.documentElement.style.fontSize = remSize
if (browers().ios) {
  window.onpageshow = function(e) {
    if (e.persisted) {
      window.location.reload(true)
    }
  }
}

new Vue({
  el: '#app',
  render: h => h(App)
})
